import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

let smoother = null

/* Butter-smooth inertia scrolling. Requires markup:
   <div id="smooth-wrapper"><div id="smooth-content">…</div></div> */
export function initSmoothScroll() {
  if (smoother) return smoother
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  smoother = ScrollSmoother.create({
    wrapper: '#smooth-wrapper',
    content: '#smooth-content',
    smooth: reduce ? 0 : 1.15,
    effects: true,
    normalizeScroll: true
  })

  // route in-page anchor clicks through the smoother
  document.addEventListener('click', onAnchorClick)
  return smoother
}

function onAnchorClick(e) {
  const a = e.target.closest('a[href^="#"]')
  if (!a || !smoother) return
  const id = a.getAttribute('href')
  if (id.length < 2) return
  const target = document.querySelector(id)
  if (!target) return
  e.preventDefault()
  smoother.scrollTo(target, true, 'top 80px')
}

export function killSmoothScroll() {
  document.removeEventListener('click', onAnchorClick)
  if (smoother) { smoother.kill(); smoother = null }
}
